<template>
  <div class="ivan-stub text-center text-muted" style="padding:50px 24px">
    <h4 style="color:#333;margin-bottom:8px">{{ title }}</h4>
    <p style="font-size:13px;line-height:1.6">{{ message }}</p>
  </div>
</template>

<script>
export default {
  name: 'IvanStub',
  computed: {
    title() {
      return (this.$route.meta && this.$route.meta.title) || '功能占位'
    },
    message() {
      const hint = this.$route.meta && this.$route.meta.hint
      if (hint) return hint
      return '该菜单在 Ivan 参考系统中存在，远诺一期尚未对接对应接口。请从待办箱或已挂接的业务菜单进入。'
    }
  }
}
</script>
